export const UPDATE_POINTS = 'UPDATE_POINTS';
export const ATTRIBUTE_BADGES = 'ATTRIBUTE_BADGES';
export const BADGE_EARNED = 'BADGE_EARNED';
export const DESTROY_POINTS = 'DESTROY_POINTS';


// WEBPACK FOOTER //
// ./src/components/Points/pointsActionTypes.js